import { z } from 'zod';
import { ErrorResponseSchema, SuccessMessageSchema } from '@/schemas/common/base';

/**
 * Delete listing parameter schema
 * Validates the listing ID from the URL path
 */
export const DeleteListingParamSchema = z.object({
  id: z.string().refine(val => {
    const num = parseInt(val, 10);
    return !isNaN(num) && num > 0;
  }, 'Invalid listing ID'),
});

export type DeleteListingParam = z.infer<typeof DeleteListingParamSchema>;

/**
 * Delete listing response schema (success or error)
 */
export const DeleteListingResponseSchema = z.discriminatedUnion('success', [
  SuccessMessageSchema,
  ErrorResponseSchema,
]);

export type DeleteListingResponse = z.infer<typeof DeleteListingResponseSchema>;
